import {extendTheme, ThemeOverride} from '@chakra-ui/react';
import foundations from './foundations';

const overrides = {
  ...foundations,
} as ThemeOverride;

export default extendTheme(overrides);
